export const responseMessages = {
  //series 4xx
  400: {
    fa: 'درخواست اشتباه',
  },
  401: {
    fa: 'نیاز به احراز هویت',
  },
  403: {
    fa: 'محدودیت دسترسی',
  },
  404: {
    fa: 'منبعی یافت نشد',
  },
  429: {
    fa: 'تعداد درخواست زیاد، لطفا لحظاتی بعد مجدد تلاش کن',
  },

  //series 5xx
  500: {
    fa: 'اوه! خطا در سیستم، لطفا مجدد تلاش کن',
  },
  501: {
    fa: 'اوه! خطا در سیستم، لطفا مجدد تلاش کن',
  },
  503: {
    fa: 'اوه! خطا در سیستم، لطفا مجدد تلاش کن',
  },
  504: {
    fa: 'اوه! خطا در سیستم، لطفا مجدد تلاش کن',
  },
  505: {
    fa: 'اوه! خطا در سیستم، لطفا مجدد تلاش کن',
  },
  511: {
    fa: 'اوه! خطا در سیستم، لطفا مجدد تلاش کن',
  },

  //default
  success: { fa: 'موفقیت آمیز بود' },
  failed: { fa: 'درخواست ناموفق بود' },
};
